var spinnerTemplate = require('rrTags/templates/tpl.spinnerOverlay.mustache');
var overlayDataAttr = 'swLoadingText';

module.exports = function($) {

  $.fn.swShowLoading = function(options) {
    options = options || {};

    var $el = $(this);

    var pos = $el.position();

    var $overlay = $(spinnerTemplate.render(options));
    $overlay.css({
      position: 'absolute',
      top: pos.top,
      left: pos.left,
      width: $el.width(),
      height: $el.height()
    });

    if ($el.is(':visible')) {
      $el.after($overlay);
    }

    var $oldOverlay = $el.data(overlayDataAttr);
    if ($oldOverlay) {
      $oldOverlay.remove();
    }
    $el.data(overlayDataAttr, $overlay);
  };

  $.fn.swHideLoading = function() {
    var $el = $(this);
    var $overlay = $el.data(overlayDataAttr);

    if ($overlay) {
      $overlay.remove();
    }

    $el.data(overlayDataAttr, null);
  };

};
